import { getLanguageCode } from 'i18n/helpers';
import numeral, { NumeralJSLocale } from 'numeral';

import 'numeral/locales'; // Need to manually import the locales formats: https://github.com/adamwdraper/Numeral-js/issues/555
import './en-ie'; // Import custom locale formats

// See http://numeraljs.com/
export const NUMERAL_FORMAT_STR_REGEX = /^[0+\-(.$][0().$,[\] ob%ai:e+]*$/;

export function lookupNumeralLocale(locale?: string): NumeralJSLocale & { code: string } {
  if (!locale) {
    return { ...numeral.localeData(), code: numeral.locale() }; // return the currently set global locale
  }

  // numeral expects lowercase locales ('fr-ca' vs 'fr-CA')
  if (numeral.locales[locale.toLowerCase()]) {
    return { ...numeral.locales[locale.toLowerCase()], code: locale.toLowerCase() };
  }

  const language = getLanguageCode(locale);
  if (numeral.locales[language]) {
    return { ...numeral.locales[language], code: language };
  }

  if (process.env.NODE_ENV === 'development') console.warn(`Unrecognized numeral locale '${locale}'`);

  return { ...numeral.locales['en'], code: 'en' };
}

export function setNumeralLocale(locale?: string) {
  const numeralLocale = lookupNumeralLocale(locale);

  numeral.locale(numeralLocale.code);

  return numeralLocale;
}

export function getCurrencySymbol(locale?: string) {
  const { currency: { symbol } } = lookupNumeralLocale(locale);

  if (!symbol && process.env.NODE_ENV === 'development') console.error(`Unable to find currency symbol for numeral locale ${locale || numeral.locale()}`);

  return symbol || '$';
}
